export const NAVIGATION = Object.freeze({
  FORWARD: 'FORWARD',
  BACKWARD: 'BACKWARD'
});



// WEBPACK FOOTER //
// ./src/constants/navigations.js